import { RegistrationDetailsRes } from '@dealstack/shared/lib/generated';

export const getJurisdictionName = (
	registrationDetails: RegistrationDetailsRes | undefined
): string | undefined => registrationDetails?.jurisdiction?.jurisdiction_name?.trim() || undefined;

export const getLegalForm = (
	registrationDetails: RegistrationDetailsRes | undefined
): { label: string; tooltip?: string } | undefined => {
	const legalForm = registrationDetails?.legalForm;

	if (!legalForm) {
		return undefined;
	}

	const fullName =
		legalForm.entity_legal_form_name_transliterated_name_per_ISO_01_140_10?.trim() ||
		legalForm.entity_legal_form_name_local_name?.trim();

	const abbreviation = legalForm.abbreviations_local_language
		?.split(';')
		.map((part) => part.trim())
		.find(Boolean);

	if (abbreviation) {
		return { label: abbreviation, tooltip: fullName };
	}

	return fullName ? { label: fullName } : undefined;
};
